import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { gql } from '@apollo/client'
import { JOBSITE_MULTI_SEARCH_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, getData } from '../CustomUtils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const JOBSITE_MULTI_SEARCH = gql(JOBSITE_MULTI_SEARCH_QUERY)

export default function JobsiteMultiSearch(props) {
  console.log('JobsiteMultiSearch rendered: ', props)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const location = useLocation()

  useEffect(() => {
    getData(location, JOBSITE_MULTI_SEARCH, 'jobsiteMultiSearch', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = []
    const columnHeadings =
      <tr>
        <th>Station, Refinery, Mill, Etc<span style={{ fontWeight: 'normal' }}><br />
            Company/Site/Vessel</span> </th>
        <th>Location</th>
        <th>Letter Date</th>
        <th>FW Contract</th>
        <th>Overall Contract Number</th>
        <th>Comments</th>
        <th>Source</th>
      </tr>

    let row = []
    for (let i = 0; i < results.length; i++) {
      for (let j = 0; j < results[i].length; j++) {
        if (j === 0) {
          row.push(<td><b>{results[i][j]}</b>{results[i][j + 1] ? <span><br />{results[i][j + 1]}</span> : null}</td>)
          j++
        } else if (j === 3) {
          row.push(<td style={{ whiteSpace: 'nowrap' }}>{results[i][j]}</td>)
        } else {
          row.push(<td>{results[i][j]}</td>)
        }
      }
      resultRows.push(<tr key={i}>{row}</tr>)
      row = []
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Custom/jobsiteMultiSearch/jobsite', location)} resultsLength={results.length} />
        </div>
        <Table bordered className="custom-table">
          <ReportHeading title={'Jobsite References Search Results'} widths={['0%', '100%', '0%']} />
          {columnHeadings}
          <tbody>
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}